import Header from "@/components/header";
import useIsSmall from "@/hooks/useIsSmall";
import useCreateMerchantServiceCategory from "@/services/appointment/hooks/useCreateMerchantServiceCategory";
import { CreateMerchantServiceFromPayload } from "@/services/appointment/type";
import {
  Button,
  Card,
  Container,
  DEFAULT_THEME,
  Stack,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

const schema = Yup.object().shape({
  title: Yup.string().required("لطفا نام سرویس را وارد نمایید"),
});

function AddCategoryService() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const isSmall = useIsSmall();
  const { mutate, isLoading } = useCreateMerchantServiceCategory();

  const form = useForm<CreateMerchantServiceFromPayload>({
    initialValues: {
      capacity: "",
      color: DEFAULT_THEME.colors.blue.slice(6, 7).toString(),
      durationPartInMinute: "",
      endTimeOfDay: "",
      startTimeOfDay: "",
      title: "",
      description: "",
      price: 0,
    },
    validate: yupResolver(schema),
  });

  const submit = (values: CreateMerchantServiceFromPayload) => {
    mutate(
      {
        title: values?.title,
        description: values?.description,
      },
      {
        onSuccess() {
          notifications.show({
            title: "عملیات موفق",
            message: "عملیات با موفقیت صورت پذیرفت",
            color: "green",
          });
          queryClient.invalidateQueries({
            queryKey: ["getMerchantServices"],
          });
          navigate(-1);
          queryClient.refetchQueries(["getMerchantServices"]);
        },
      }
    );
  };

  return (
    <>
      <Header
        title="افزودن دسته بندی خدمات"
        showBack
        route="/dashboard/schedule/services"
      />
      <Container mb="100px" w="100%" size="md" bg="white">
        <Title order={4}>افزودن دسته بندی خدمات</Title>

        <Stack mt="md" justify="start" flex={1}>
          <form
            onSubmit={form.onSubmit(submit)}
            name="add-service"
            className="w-100"
            id="add-service"
          >
            <Stack>
              <TextInput
                styles={{
                  label: {
                    fontSize: "1rem",
                  },
                }}
                size="lg"
                placeholder=""
                withAsterisk
                description="به عنوان مثال : مو"
                label="عنوان"
                {...form.getInputProps("title")}
              />

              <Textarea
                styles={{
                  label: {
                    fontSize: "1rem",
                  },
                }}
                size="lg"
                label="توضیحات"
                {...form.getInputProps("description")}
              />
            </Stack>
          </form>
        </Stack>
      </Container>
      {isSmall ? (
        <Card
          styles={{
            root: {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 10,
            },
          }}
          withBorder
          radius={0}
        >
          <Button
            size="lg"
            fullWidth
            type="submit"

            form="add-service"
            loading={isLoading}
          >
            افزودن
          </Button>
        </Card>
      ) : (
        <Container w="100%" size="md" bg="white">
          <Button
            size="lg"
            fullWidth
            type="submit"

            form="add-service"
            loading={isLoading}
          >
            افزودن
          </Button>
        </Container>
      )}
    </>
  );
}

export default AddCategoryService;
